import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

const ProjectInfo = ({ stack, projectUrl, githubUrl }) => {
  const { t } = useTranslation();

  return (
    <div className="portfolio-info">
      <h3>{t("Project information")}</h3>
      <ul>
        <li>
          <strong>Stack</strong>: {stack}
        </li>
        <li>
          <strong>{t("Project URL")}</strong>:
          <a href={projectUrl}>{projectUrl}</a>
        </li>

        {githubUrl && (
          <li>
            <strong>GitHub</strong>:<a href={githubUrl}>{githubUrl}</a>
          </li>
        )}
      </ul>
    </div>
  );
};

ProjectInfo.propTypes = {
  stack: PropTypes.string.isRequired,
  projectUrl: PropTypes.string.isRequired,
  githubUrl: PropTypes.string.isRequired,
};

export default ProjectInfo;
